export default "__VITE_ASSET__Df$x2YKI__"